<template>
  <div class="hometop-bg" :class="startAnim">
    <div class="htinner">

      <div v-for="job in jobs" class="job-img" :class="setClassName(job.slug,job.alias,job.resp)" :key="job.index">
        <img :src="setImgPath(job.slug,'obj')" :alt="job.name" class="imgo">
        <img :src="setImgPath(job.slug,'person')" :alt="job.name" class="imgp">
      </div>

      <p class="bln -bln01">働きがいって？</p>
      <p class="bln -bln02">どんな商談をするの？</p>
      <p class="bln -bln03">どんな能力がいるの？</p>
      <p class="bln -bln04">どんな組織？</p>

    </div><!-- .htinner -->
  </div><!-- .hometop-bg -->
</template>

<script>
  export default {
    data(){
      return{
        startAnim: "",
        jobs: [
          {
            name: "人材",
            slug: "staffagency",
            alias: null,
            resp:null
          },
          {
            name: "IT",
            slug: "it",
            alias: null,
            resp:null
          },
          {
            name: "食品",
            slug: "foodcompany",
            alias: null,
            resp: true
          },
          {
            name: "ディーラー",
            slug: "cardealer",
            alias: null,
            resp: true
          },
          {
            name: "商社",
            slug: "shosha",
            alias: null,
            resp: true
          },
          {
            name: "商社",
            slug: "shosha",
            alias: "-shosha02",
            resp:null
          },
          {
            name: "保険",
            slug: "insurance",
            alias: null,
            resp:null
          },
          {
            name: "保険",
            slug: "insurance",
            alias: "-insurance02",
            resp:null
          },
          {
            name: "銀行",
            slug: "bank",
            alias: null,
            resp:null
          },
          {
            name: "銀行",
            slug: "bank",
            alias: "-bank02",
            resp:null
          },
          {
            name: "不動産",
            slug: "estate",
            alias: null,
            resp:null
          },
          {
            name: "製薬",
            slug: "mr",
            alias: null,
            resp:null
          },
          {
            name: "製薬",
            slug: "mr",
            alias: "-mr02",
            resp:null
          },
          {
            name: "証券",
            slug: "securities",
            alias: null,
            resp: true
          }
        ]             
      }
    },
    computed: {
      setClassName() {
        return function (val,alias,resp) {
          let cname
          if( alias ){
            cname = "-" + val + " " + alias;
          }else{
            cname = "-" + val;
          }
          if( resp ){
            cname = cname + " -resp";
          }
          return cname;

        };
      },
      setLink() {
        return function (val) {
          return "/" + val;
        };
      },
      setImgPath() {
        return function (val,fn) {
          // return "../assets/img/" + val + "/" + fn + ".svg";
          return require("@/assets/img/" + val + "/" + fn + ".svg");
        };
      },
    },
    mounted: function () {
      this.$nextTick(function () {
        // ビュー全体がレンダリングされた後にのみ実行されるコード
        this.startAnim = "-active";
      })
    },

  }
</script>